module.exports = __webpack_public_path__ + "media/images/writer/community/button@3x-c1b034610590427c95d899cdee6a9c4d.png";